<div fxLayout="column" id="htmlData" hidden #htmlData fxLayoutAlign="center center" class="certificate-container">
  <div fxLayout="column" fxLayoutAlign="start stretch" class="certificate"  [ngStyle]="{'background-image': 'url(' + serverPath + certificateBackgroundImg + ')', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
    <h1 fxLayoutAlign="start" style="font-family: 'League Gothic'; font-size: 53px;">CERTIFICATE</h1>
    <h1 fxLayoutAlign="start" class="contents">of Participation</h1>
    <p fxLayoutAlign="start">This certificate is presented to </p>
      <h1 class="name" fxLayoutAlign="start">{{username}}
    </h1>
  
    <p fxLayoutAlign="start" class="contents">for Successfully Completing the <span [innerHTML]="product.name"></span>
    </p>

    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" class="details">
      <div fxFlex="40%" fxLayout="column" fxLayoutAlign="center" id="1">
        <h3>Signature</h3>
        <img [src]="serverPath1 + courseManagerSign" alt="Signature" class="contents" style="width:120px;height: 36px;">
        <div class="footer-underline"></div>
        <p class="contents">Professor</p>
      </div>
      <div fxFlex fxLayout="column" fxLayoutAlign="center" id="2">
        <h3>Signature</h3>
        <img [src]="LecturerServerPath+LectureDetails?.logo" [alt]="LectureDetails?.logo" style="width:120px;height: 36px;">
        <div class="footer-underline"></div>
        <p class="contents">Instructor</p>
      </div>
    </div>
  </div>
</div>